export default __webpack_public_path__ + "static/media/Boots of the First Circle.77f7de9a.jpg";